import React from 'react'
import Header from '../../components/Header/Header.jsx'
import './contact.css'
import SocialIconsContainer from '../../components/Container/SocialIconsContainer.jsx'
function Contact() {
    const [option,setOption]=React.useState("Help")
  return (
    <div className='body'>
      <Header/>
      <div className='contact'>
    <p>Contact</p>
    <div className='contact-card'>
      <div className='contact-content'>
       <div className='BtnContainer'>
       <div className={option=='Help'?'Btn Active':'Btn'} onClick={()=>setOption('Help')}>
       <p>Help</p>
       </div>
    
        <div className={option=='Feedback'?'Btn Active':'Btn'} onClick={()=>setOption('Feedback')} >
       <p>Feedback</p>
       </div>
       </div>
       {option=="Help"?
      <p className='ContactMessage'>
       If you require help with BuxSwap for Egg Heads Club, please open a support ticket in the Egg Heads Club server.<br/><br/> For other projects, please contact us via email.
       </p>:
        <p className='ContactMessage'>
        If you would like to see improvements with the Egg Heads Club exchange interface, please message in the feedback channel within the Egg Heads Club server.<br/><br/> For other projects, please contact us via email.
        </p>
       }
        <a href='https://discord.com/invite/HTsxXGcwTD' target='_blank'  className='gotoDiscordBtn'>
     
        <div className='innerContainer'>
            <img className='discord-img' src='/assets/Discord.png'/>
            <img className='discord-gradient-img'src='/assets/Discord-Gradient.png'/>
            <p>Go to Discord</p>
       
      </div>
      </a>
      </div>

    </div>
  </div>
  <SocialIconsContainer/>
  </div>
  )
}

export default Contact